/* --------------------------------------------------------------------------------------
privacyStatementLanguage.service.js
   Copyright © 2020 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

/* eslint-disable comma-spacing */
export class privacyStatementLanguageService {
  constructor(deviceInfoService) {
    this.deviceInfoService = deviceInfoService;
  }
  isDefault() {
    const currentLang = this.getCurrentLang(),
      availableLangs = this.getAvailableForeignLanguages();

    return !availableLangs.includes(currentLang);
  }
  isCurrent(lang) {
    const currentLang = this.getCurrentLang();
    if (!currentLang) return false;

    return currentLang.toLowerCase().startsWith(lang.toLowerCase());
  }
  getCurrentLang() {
    if (!this.lang) {
      this.lang = this.deviceInfoService.getLanguage();
    }
    return this.lang;
  }
  getAvailableForeignLanguages() {
    return ["ca"];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/privacyStatementLanguage.service.js